import { Box, Typography, useMediaQuery } from '@mui/material'
import { pxToRem, pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils'
import { IStyles } from 'libs/shared-ui/src/commonUtils/styleUtils'
import ImageWrapper from '../../elements/ImageWrapper'
import { theme } from 'libs/shared-ui/src/theme/themeProvider'
const styles: IStyles = {
  root: {
    display: 'flex',
    width: { xs: pxToRem(268), md: pxTovW(600), lg: pxTovW(467) },
    height: { xs: pxToRem(72), md: pxTovW(184), lg: pxTovW(124) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    gap: { xs: pxToRem(8), md: pxTovW(12) },
    cursor: 'pointer'
  },
  logo: {
    width: { xs: pxToRem(62), md: pxTovW(153), lg: pxTovW(113) },
    height: 'auto'
  }
}
interface IProps {
  background?: string;
  imageName?: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
}
export const ModuleButton = (props: IProps) => {
  const { background, imageName, title, subtitle, onClick } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;
  return (
    <Box sx={{ ...styles.root, backgroundColor: background ? background : '#FEEDAE', }} onClick={onClick}>
      <ImageWrapper
        name={imageName ? imageName : "home_library"}
        type="png"
        parentFolder="icons"
        styles={styles.logo}
      />
      <Box sx={{
        width: { xs: pxToRem(165), md: pxTovW(344), lg: pxTovW(244) },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: { xs: pxToRem(2), md: pxTovW(16) }
      }}>
        <Typography variant={isIpadOnly ? 'h4' : 'h3'} fontWeight={600}>{title}</Typography>
        <Typography variant={isIpadOnly ? 'h5' : 'h4'} sx={{
          display: {
            xs: '-webkit-box', md: 'flex'
          },
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
        }
        } fontWeight={500}>{subtitle}</Typography>
      </Box>
      <Box sx={{
        marginY: 'auto',
        marginRight: { xs: pxToRem(10), md: pxTovW(11) },
        marginLeft: 'auto'
      }}>
        <ImageWrapper
          styles={{
            width: { xs: pxToRem(18), md: pxTovW(55), lg: pxTovW(41) },
            height: { xs: pxToRem(18), md: pxTovW(55), lg: pxTovW(41) },
          }}
          name="right-arrow-circle"
          type="png"
          parentFolder="illustrations"
        />
      </Box>
    </Box >
  )
}
